import { RootState } from "../../../../store";
import { schedulesStateSelector } from "../../schedulesStateSelector";

export const previewSelectedResourceIdsSelector = (state: RootState) => {
  const schedule = schedulesStateSelector(state);

  return schedule.previewSelectedResources;
};
